/**
 * @module estimateTerm
 * @description A list of estimateTerm
 */
export const estimateTerm = [
	{
		name: 'Default',
		remark: 'This estimate is an approximation and is not guaranteed. The estimate is based on information provided from the client regarding project requirements. Actual cost may change once all project elements are finalized or negotiated. Prior to any changes of cost, the client will be notified. Estimate valid for 30 days.',
	},
]
